import { ROUTE_CUSTOM_MODULE } from '../../../constants/routePath';
import moduleStore from 'store/moduleStore';
import { get } from 'lodash';

export class CustomModuleRouteHelper {

  static ROOT_PATH = `/${ROUTE_CUSTOM_MODULE}`;

  static ID_QUERY = 'id';

  getModuleCodeFromQuery(query) {
    return get(query, CustomModuleRouteHelper.ID_QUERY);
  }

  isValidModulePath(query) {
    const moduleCode = this.getModuleCodeFromQuery(query);
    if (!moduleCode) {
      return false;
    }
    return moduleStore.isModuleAvailable(moduleCode);
  }

}

export const customModuleRouteHelper = new CustomModuleRouteHelper();
